import { Action, createReducer, on } from '@ngrx/store';
import * as actions from '../actions';
import { IGetBulkEmployeeUpdateFromExcelStatusResponse } from '../models/get-bulk-employee-update-from-excels-status.model';

export const getBulkEmployeeUpdateFromExcelsStatusKey = 'getBulkEmployeeUpdateFromExcelsStatus';
export interface BulkEmployeeUpdateFromExcelsStatusState {
  getBulkEmployeeUpdateFromExcelsStatusResponse: IGetBulkEmployeeUpdateFromExcelStatusResponse;
  getBulkEmployeeUpdateFromExcelsStatusResponseFailure: any;
  loaded: boolean;
}

export const initialState: BulkEmployeeUpdateFromExcelsStatusState = {
  getBulkEmployeeUpdateFromExcelsStatusResponse: undefined,
  getBulkEmployeeUpdateFromExcelsStatusResponseFailure: undefined,
  loaded: false
};

export const reducer = createReducer(
  initialState,
  on(actions.getBulkEmployeeUpdateFromExcelsStatus, (state, action) => ({
    ...state
  })),
  on(actions.getBulkEmployeeUpdateFromExcelsStatusSuccess, (state, action) => ({
    ...state,
    getBulkEmployeeUpdateFromExcelsStatusResponse: action.response,
    loaded: true
  })),
  on(actions.getBulkEmployeeUpdateFromExcelsStatusFailure, (state, action) => ({
    ...state,
    getBulkEmployeeUpdateFromExcelsStatusFailure: action.error
  })),
  on(actions.getBulkEmployeeUpdateFromExcelsStatus, (state, action) => ({
    ...state,
    getBulkEmployeeUpdateFromExcelsStatusResponse: undefined,
    loaded: false
  }))
);

export const getBulkEmployeeUpdateFromExcelsStatusResponse = (state: BulkEmployeeUpdateFromExcelsStatusState) => {
  if (state && state.getBulkEmployeeUpdateFromExcelsStatusResponse)
    return JSON.parse(JSON.stringify(state.getBulkEmployeeUpdateFromExcelsStatusResponse));
  else return null;
};

export const getBulkEmployeeUpdateFromExcelsStatusIsLoaded = (state: BulkEmployeeUpdateFromExcelsStatusState) => {
  state.loaded;
};
